import type { ReactNode } from "react";
import "./videoStage.css";

type VideoStageProps = {
  children: ReactNode;
};

export function VideoStage({ children }: VideoStageProps) {
  return (
    <div className="video-stage">
      <div className="video-stage-inner">{children}</div>
    </div>
  );
}
